import React from 'react';

export default function IndexSectionApplication7() {
    return (
        <React.Fragment>
            <>
                <section id={'get-app'} className="py-20">
                    <div className="container mx-auto px-4">
                        <h1 className="font-heading text-center text-4xl lg:text-5xl font-bold mb-3">Find your new
                            favorite restaurant
                        </h1>
                        <p className="text-gray-600 text-center mb-6 max-w-lg mx-auto">FindAMeal collects deep insights
                            about restaurants to provide you with the best match possible for your mood</p>
                        <div className="flex flex-wrap justify-center gap-4 mb-16 lg:mb-56">
                            <a className="inline-block" href="https://apps.apple.com/us/app/findameal/id6736911377">
                                <img src="cronos-assets/buttons/app-store.svg" alt/>
                            </a>
                            <a className="inline-block"
                               href="https://play.google.com/store/apps/details?id=ai.findameal">
                                <img src="cronos-assets/buttons/google-play.svg" alt/>
                            </a>
                        </div>
                        <div className="flex flex-wrap -m-4">
                            <div className="w-full lg:w-1/3 p-4">
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 40H40" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 40V34L34 8L40 14L14 40H8Z" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                    strokeLinejoin="round"/>
              <path d="M34 20L28 14" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Find local hiddem gems</h6>
                                        <p className="text-gray-500 max-w-xs">We recommend good matches even if they are
                                            not trendy yet</p>
                                    </div>
                                </div>
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 44C24 44 40 36 40 24V10L24 4L8 10V24C8 36 24 44 24 44Z" stroke="#006251" strokeWidth={2}
                    strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 23L22 29L34 17" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                    strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Get insights</h6>
                                        <p className="text-gray-500 max-w-xs">We compile information about the
                                            restaurant to make your decision making simple</p>
                                    </div>
                                </div>
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M24 30C27.866 30 31 26.866 31 23C31 19.134 27.866 16 24 16C20.134 16 17 19.134 17 23C17 26.866 20.134 30 24 30Z"
                  stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path
                  d="M42 23.9999C42.006 28.6858 40.1784 33.188 36.908 36.5439C35.2324 38.2727 33.2261 39.6466 31.0086 40.5839C28.791 41.5213 26.4075 42.0028 24 41.9999C21.5925 42.0028 19.209 41.5213 16.9914 40.5839C14.7739 39.6466 12.7676 38.2727 11.092 36.5439C9.03644 34.4289 7.53208 31.8412 6.71122 29.0084C5.89036 26.1757 5.77815 23.1846 6.38447 20.2982C6.99079 17.4119 8.29705 14.7188 10.1884 12.4557C12.0797 10.1927 14.4981 8.42904 17.2309 7.31992C19.9638 6.2108 22.9273 5.79019 25.8608 6.09509C28.7943 6.39998 31.608 7.42103 34.0543 9.06844C36.5006 10.7159 38.5047 12.9391 39.8902 15.5428C41.2757 18.1464 42.0002 21.0506 42 23.9999V23.9999Z"
                  stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path
                  d="M11.092 36.544C12.5768 34.5144 14.5197 32.8639 16.7627 31.7268C19.0056 30.5897 21.4853 29.9981 24 30C26.5148 29.9981 28.9945 30.5897 31.2374 31.7268C33.4804 32.8639 35.4233 34.5144 36.908 36.544"
                  stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Create your lists</h6>
                                        <p className="text-gray-500 max-w-xs">Become a curator of the best spots in your
                                            area</p>
                                    </div>
                                </div>
                            </div>
                            <div className="w-1/3 hidden lg:block">
                                <img className="mx-auto block -mt-32" style={{maxHeight: 556}}
                                     src="https://static.shuffle.dev/uploads/files/91/912295578c198379538e8973cd408b5d4407df70/cover-serach.png"
                                     alt/>
                            </div>
                            <div className="w-full lg:w-1/3 p-4">
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 14L24 6L40 14V34L24 42L8 34V14Z" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                    strokeLinejoin="round"/>
              <path d="M30 18L18 30" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M18 18L30 30" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Share with others</h6>
                                        <p className="text-gray-500 max-w-xs">Friends will be able to follow your
                                            recommendations and tell whether they also liked the restaurant or not</p>
                                    </div>
                                </div>
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M38 14C39.8965 16.9689 40.7142 20.4997 40.316 24V26C40.3165 28.1166 40.899 30.1923 42 32"
                    stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path
                  d="M16 22C16 19.8783 16.8429 17.8434 18.3431 16.3431C19.8434 14.8429 21.8783 14 24 14C26.1217 14 28.1566 14.8429 29.6569 16.3431C31.1571 17.8434 32 19.8783 32 22V24C32 28.3274 33.4036 32.5381 36 36"
                  stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M24 22V26C23.992 31.72 26.086 37.302 30 42" stroke="#006251" strokeWidth={2}
                    strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 30C16.544 34.18 17.898 38.24 20 42" stroke="#006251" strokeWidth={2} strokeLinecap="round"
                    strokeLinejoin="round"/>
              <path
                  d="M9.82188 38C8.47392 33.4672 7.86677 28.7464 8.02388 24.02V22.02C8.01783 19.9182 8.42661 17.8359 9.22679 15.8924C10.027 13.9489 11.2028 12.1824 12.687 10.6942C14.1711 9.206 15.9343 8.02529 17.8756 7.21976C19.8169 6.41424 21.8981 5.99973 23.9999 6C26.8082 5.99835 29.5674 6.73644 31.9999 8.14"
                  stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Leave your food-print</h6>
                                        <p className="text-gray-500 max-w-xs">Imagine showing everyone your favs</p>
                                    </div>
                                </div>
                                <div className="mb-8 flex">
          <span className="mr-6">
            <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 40H42V8H6" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M42 8L24 26L6 8" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M8 22H2" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 32H2" stroke="#006251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
                                    <div>
                                        <h6 className="text-xl mb-2">Share with the world</h6>
                                        <p className="text-gray-500 max-w-xs">Enjoy the AI for restaurants</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </>
        </React.Fragment>
    );
}

